import { render } from "./RadioHorizontal.vue?vue&type=template&id=d5f58978"
import script from "./RadioHorizontal.vue?vue&type=script&lang=js"
export * from "./RadioHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/rizome.dvit.cloud/httpdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__